import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import {
  getListingAddressPublicTooltipKey,
  getListingAmountDisplayValue,
  getListingBuildingShortAddress,
  getListingConversionDisplayValue,
  getListingCoverThumbnail,
  getListingDaysToLetDisplayValue,
  getListingRentDisplayValue,
  getListingReportingDisplayValue,
  getListingUnitLabel,
  LISTING_COLUMN_NAME,
  RentalPortalListingObjectCell,
  toListingUserCellValue,
} from '../../../RentalPortalListing'
import {
  TableCellBase,
  TableDateCell,
  TableTextCell,
  TableUserCell,
  TableVisibilityCell,
} from '../../../Table'
import { getIsListingAvailableImmediately } from '../../RentalPortal.utils'
import { RentalPortalWaitingOnCell } from '../../RentalPortalWaitingOnCell'
import { RentalPortalListingsApplicantsCell } from '../RentalPortalListingsApplicantsCell'
import { RentalPortalListingsPortalsCell } from '../RentalPortalListingsPortalsCell'
import { RentalPortalListingsStatusCell } from '../RentalPortalListingsStatusCell'

export function getIsListingRowActive({ activeItem, focusedRow, id }) {
  return focusedRow === id || activeItem === id
}

export function renderCell({ item, name, t, timezone, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case LISTING_COLUMN_NAME.Unit:
      return (
        <TableCellBase {...restProps}>
          <RentalPortalListingObjectCell
            photo={{ thumb_url: getListingCoverThumbnail(item) }}
            title={getListingUnitLabel({ listing: item, t })}
          />
        </TableCellBase>
      )
    case LISTING_COLUMN_NAME.Building:
      return (
        <TableTextCell
          {...restProps}
          value={getListingBuildingShortAddress(item.flat?.building)}
        />
      )
    case LISTING_COLUMN_NAME.Status:
      return <RentalPortalListingsStatusCell {...restProps} item={item} />
    case LISTING_COLUMN_NAME.Rent:
      return (
        <TableTextCell
          {...restProps}
          value={getListingRentDisplayValue(item)}
        />
      )
    case LISTING_COLUMN_NAME.AvailableFrom:
      return getIsListingAvailableImmediately({
        availableFrom: value,
        timezone,
      }) ? (
        <TableTextCell
          {...restProps}
          value={t('RentalPortal.ListingAvailableImmediatelyKey')}
        />
      ) : (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_SHORT_FORMAT}
          useTodayFormat={false}
          value={value}
        />
      )
    case LISTING_COLUMN_NAME.Created:
    case LISTING_COLUMN_NAME.Updated:
    case LISTING_COLUMN_NAME.ScheduledGoLive:
    case LISTING_COLUMN_NAME.ScheduledDeactivate:
    case LISTING_COLUMN_NAME.FirstPublishedAt:
    case LISTING_COLUMN_NAME.ClosedAt:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_SHORT_FORMAT}
          useTodayFormat={false}
          value={value}
        />
      )
    case LISTING_COLUMN_NAME.ServiceCharge:
    case LISTING_COLUMN_NAME.HeatingCosts:
    case LISTING_COLUMN_NAME.OtherCosts:
    case LISTING_COLUMN_NAME.DepositAmount:
      return (
        <TableTextCell
          {...restProps}
          value={getListingAmountDisplayValue({
            amount: value,
            currency: item.currency,
          })}
        />
      )
    case LISTING_COLUMN_NAME.CreatedBy:
    case LISTING_COLUMN_NAME.ResponsibleManager:
      return (
        <TableUserCell {...restProps} value={toListingUserCellValue(value)} />
      )
    case LISTING_COLUMN_NAME.Photos:
      return <TableTextCell {...restProps} value={item.photo_count} />
    case LISTING_COLUMN_NAME.AddressPublic:
      return (
        <TableVisibilityCell
          {...restProps}
          disabled
          getButtonTooltip={getListingAddressPublicTooltipKey}
          isVisible={value}
        />
      )
    case LISTING_COLUMN_NAME.WaitingOn:
      return (
        <RentalPortalWaitingOnCell {...restProps} attention={item.attention} />
      )
    case LISTING_COLUMN_NAME.Portals:
      return <RentalPortalListingsPortalsCell {...restProps} summary={value} />
    case LISTING_COLUMN_NAME.Inquiries:
    case LISTING_COLUMN_NAME.ViewingCount:
    case LISTING_COLUMN_NAME.Applications:
      return (
        <TableTextCell
          {...restProps}
          value={getListingReportingDisplayValue(value)}
        />
      )
    case LISTING_COLUMN_NAME.DaysToLet:
      return (
        <TableTextCell
          {...restProps}
          value={getListingDaysToLetDisplayValue(value)}
        />
      )
    case LISTING_COLUMN_NAME.Conversion:
      return (
        <TableTextCell
          {...restProps}
          value={getListingConversionDisplayValue(value)}
        />
      )
    case LISTING_COLUMN_NAME.Applicants:
      return (
        <RentalPortalListingsApplicantsCell
          {...restProps}
          count={value}
          newCount={item.applicants?.new_count}
        />
      )
    default:
      return <TableTextCell {...restProps} value={value} />
  }
}
